import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Icon, NamedLink } from '../../components';

import actionFirstImage from './img/action1-img.avif';
import actionSecondImage from './img/action2-img.avif';

import css from './AboutPage.module.css';

const SectionAction = () => {
  return (
    <div className={css.sectionAction}>
      <h2 className={css.actionTitle}>
        <FormattedMessage id="AboutPage.actionTitle" />
      </h2>
      <div className={css.actionContent}>
        <NamedLink className={css.actionLink} name="AudiencePage">
          <img
            className={css.actionImage}
            loading="lazy"
            src={actionFirstImage}
            alt="Start involving"
          />
          <div className={css.actionImageText}>
            <h3 className={css.actionImageTitle}>
              <FormattedMessage id="AboutPage.actionImageText" />
            </h3>
            <Icon name="arrowRight" size={24} />
          </div>
        </NamedLink>
        <NamedLink className={css.actionLink} name="CreatorsPage">
          <img
            className={css.actionImage}
            loading="lazy"
            src={actionSecondImage}
            alt="Start attracting"
          />
          <div className={css.actionImageText}>
            <h3 className={css.actionImageTitle}>
              <FormattedMessage id="AboutPage.actionImageSecondText" />
            </h3>
            <Icon name="arrowRight" size={24} />
          </div>
        </NamedLink>
      </div>
    </div>
  );
};

export default SectionAction;
